import { Models } from "openai/resources"
import * as globals from "../globals"
import * as apiService from "../utils/apiService"
import { getMeta } from '../utils/metaUtils'
import { applyConditions, getPriceLevelLabels } from '../utils/dcmUtils'
import { actionCreators as GlobalStoreCreator } from '../store/General'
import { actionCreators as FilterActionCreator } from '../store/Filter'
import {
	STUDY_RESET,	
	FORD_FORECAST,
	FORD_FORECAST_REQUEST,
	FORD_UPDATE_FORECAST,
	CLEAR_FORECASTS,
	FORD_SAVE_ADD_ON
	// @ts-ignore
} from "./action-types"


export interface FordForecastState {
	[key: string]: any
}

const initialState: FordForecastState = {}

// const hackConfig = (config: any) => {
// 	return {
// 		...config,
// 		price: (config.price - 0.32) * 3000,
// 		cashback: config.cashback * 400,
// 	}
// }

export const actionCreators = {
	// forecast the loaded scenario
	
	ford_forecast: (_filter: any, callback: any, filterDatasetId: any, modelName: any) => async (dispatch: any, getState: any) => {

		dispatch(GlobalStoreCreator.setGlobalStore('forecast_needed', false))
		dispatch(GlobalStoreCreator.setGlobalStore('forecast_running', true))
		
		// we are supporting passing in a single filter or multiple
		let modelFilters: any = _filter
		if (!Array.isArray(modelFilters)) {
			modelFilters = [modelFilters]
		}
		
		const state = getState()
		const auth = state.auth
		const studyId = state.study.uid
		const model = state.model
		const selfilter = filterDatasetId ? state.filter.selected?.[filterDatasetId] : state.filter.selectedFilter

		// console.log('selfilter', selfilter)

		//need list of price/msrp/cost...labels

		const activeConfig = modelName || model.activeConfig
		// console.log('FORDFORECAST model', activeConfig);
		const modelInfo = model[activeConfig]?.modelInfo

		const costs = await getMeta(studyId, auth, 'levelcosts')
		
		const config = model[activeConfig]?.config
		// console.log('config', config);
		// const fModel = await getMeta(studyId, state.auth, model[activeConfig].modelInfo.name)
		if (!config) {
			console.log("cancelling forecast due to config not found")
			return
		}

        let attLookups: any = null
		const fetchMeta = async () => {
            
            let lookups = await getMeta(studyId, auth, modelInfo?.attConditionsLookups)
            if (lookups) {
                attLookups = lookups
            }
        }

		if(modelInfo?.attConditionsLookups?.length > 0)
			await fetchMeta()
		
		const levelLabels = await getPriceLevelLabels(config.play, attLookups)
		// console.log('attLookups', attLookups)
		// console.log('levelLabels', levelLabels)

		let assump = state.general?.custom?.ford_ass
		if (!assump) {
			assump = await getMeta(studyId, auth, "fordAssumptionsV2")
		}		

		const filterName = selfilter?.name
		const modelInfo_copy = JSON.parse(JSON.stringify(modelInfo))

		// Check if the activeConfig is one of the valid configurations ford models
		if (["dcm_ml_truck_2024", "dcm_ml_suv_2024", "dcm_ml_truck_2025", "dcm_ml_suv_2025", "dcm_ml_truck_2026", "dcm_ml_suv_2026"].includes(activeConfig)) {
			let totalMarketVolume = -1

			const year =
				activeConfig === "dcm_ml_truck_2024" || activeConfig === "dcm_ml_suv_2024" ? 2024 :
					activeConfig === "dcm_ml_truck_2025" || activeConfig === "dcm_ml_suv_2025" ? 2025 :
						activeConfig === "dcm_ml_truck_2026" || activeConfig === "dcm_ml_suv_2026" ? 2026 :
							-1

			if (["dcm_ml_truck_2024", "dcm_ml_truck_2025", "dcm_ml_truck_2026"].includes(activeConfig)) {
				// Assign Pickup Truck Demand
				totalMarketVolume = assump[`dcm_tam_consideration_${year}`]?.Pickup_Truck_Demand || modelInfo_copy.totalMarketVolume
			} else {
				// Assign SUV Segment Demand
				totalMarketVolume = assump[`dcm_tam_consideration_${year}`]?.SUV_Segment_Demand || modelInfo_copy.totalMarketVolume
			}

			modelInfo_copy.totalMarketVolume = totalMarketVolume
		} 

		// console.log("modelInfo_copy", modelInfo_copy)

		// console.log('FORD FORECASWTER: play', config.play);
		// Prepare the query
		const _query = {
			studyId: studyId,
			//uFilter: modelfilter.syntax, //selfilter.name === 'total' ? modelfilter.syntax : (selfilter.syntax + ' AND ' + modelfilter.syntax),
			uFilterName: filterName,
			modelInfo: modelInfo_copy,// model[activeConfig]?.modelInfo,
			config: config.play,
			brandvalues: config.brandvalues || [],
			//etag: config.etag,
			playHash: config.playHash,
			levelLabels,
			levelcosts: costs
		}

		// console.log('fordforecaster query', _query);

		dispatch({
			type: 'FORD_FORECAST_REQUEST',
			modelName: activeConfig,
			playHash: config.playHash,
			//filterSyntax: query.uFilter,
			filterName: filterName,
		})
		
		//console.log('FORECASTER query', query)
		// dispatch(FilterActionCreator.selectFilter('default', query.uFilter, query.uFilterName))
		// console.log('query', query)


		const url = `${globals.apiRoot}/compute/model`
		try {

			let modelData: any = null

			for (let modelFilter of modelFilters) {

				const query = {
					..._query,
					uFilter: modelFilter.syntax
				}
				// console.log('FORD FORECAST query', query);
				const response = await apiService.aPost(state.auth, url, query)
				let data = await response.json()

				// console.log('data', data);

				data = data?.[filterName]

				if (data && modelFilter.productIds?.length) {
					const newData: any = {}
					for (let uid of modelFilter.productIds) {
						newData[uid] = data[uid]
					}
					data = newData
				}

				if (data) {
					modelData = {
						...modelData,
						...data
					}
				}
				// console.log('forecast response:', resp)			
				
			}

			
			if (modelData) {
				
				//store this in forecaster.fordcollection
				await dispatch({
					type: 'FORD_FORECAST',
					data: {
						[filterName]: modelData
					},
					playHash: config.playHash,
					//filtersyntax: query.uFilter,
					filtername: filterName,
					activeConfig,
					products: config.play
				})
				callback && callback(true)

				dispatch({type: 'FORD_FORECAST_REQUEST', modelName: activeConfig, playHash: null, filterName: filterName})
				dispatch(GlobalStoreCreator.setGlobalStore('forecast_running', false))
			
			}
			else {
				// const errorText = await response.text() // Get the error message as text
					
				callback && callback(false, "Forecast request failed:")//, errorText)
				console.error("Forecast request failed:")//, errorText)
				// dispatch({
				// 	type: "FORECAST_RECEIVE",
				// 	error: response.statusText || "error",
				// 	value: null,
				// 	etag: cfgmodel.etag,
				// 	filtername: query.uFilterName,
				// 	model: activeConfig
				// })
					
			}
		} catch (err: any) {
			callback && callback(false, "Error during forecast computation:", err)
			console.error("Error during forecast computation:", err)
			// dispatch({
			// 	type: "FORECAST_RECEIVE",
			// 	error: err.message,
			// 	value: null,
			// 	etag: cfgmodel.etag,
			// 	filtername: query.uFilterName,
			// 	model: activeConfig
			// })
				
		}
	},

	setForecast: (payload:any) => async (dispatch: any, getState: any) => {

		const { filterName, data, playHash, activeConfig, products } = payload 
		// console.log('FORD_FORECAST filterName', filterName);
		// console.log('FORD_FORECAST data', data);
		// console.log('FORD_FORECAST playHash', playHash);
		// console.log('FORD_FORECAST activeConfig', activeConfig);
		// console.log('FORD_FORECAST products', products);

		// console.log('data structure', { [filterName]: data });

		await dispatch({
			type: FORD_FORECAST,
			data: { [filterName]: data }, 
			playHash,
			filtername: filterName,
			activeConfig,
			products
		})

		dispatch({type: 'FORD_FORECAST_REQUEST', modelName: activeConfig, playHash: null, filterName})

	},

	clearFordForecasts: () => async (dispatch: any, getState: any) => {
			dispatch({ type: 'CLEAR_FORECASTS'})

	},

	updateForecaster: (data: any) => async (dispatch: any, getState: any) => {
		console.error("shouldn't call updateForecaster")
		// if (data) {
		// 	dispatch({ type: 'FORD_UPDATE_FORECAST', data})
		// }
	},

	saveAddOnNumber: (modelName: string, filterName: string, addOnNumber: number) => async (dispatch: any, getState: any) => {
		dispatch({
			type: FORD_SAVE_ADD_ON,
			payload: { modelName, filterName, addOn: addOnNumber }
		})
	},

}

	

export const reducer = (state: FordForecastState = initialState, action: any) => {

	switch (action.type) {
		case 'STUDY_RESET':
			return initialState

		case 'FORD_FORECAST_REQUEST': //just changes runningPlayHash state

			const { modelName, filterName, playHash } = action
			// console.log('FORD_FORECAST_REQUEST modelname', modelName);
			// console.log('FORD_FORECAST_REQUEST filtername', filterName);
			// console.log('FORD_FORECAST_REQUEST playHash', playHash);
			
			return {
				...state,
				[modelName]: {
					...state[modelName],
					[filterName]: {
						...state[modelName]?.[filterName],
						runningPlayHash: playHash
					}
				}
			}
		
		case 'FORD_SAVE_ADD_ON': {
			const { modelName, filterName, addOn } = action.payload

			return {
				...state,
				[modelName]: {
					...state[modelName],
					[filterName]: {
						...state[modelName]?.[filterName],
						addOn, 
					},
				},
			}
		}

		
		case 'FORD_FORECAST': {
			const { data, playHash, filtersyntax, filtername, activeConfig, products } = action

			const modelName = activeConfig			
			let results: any = {}
			let prevResults = null  
			console.log('data in FORD FORECST', data);

			// Extract the numerical value from modelname (e.g., "model1" becomes 1)
			if (filtersyntax?.includes('model')) {

				// this should be obsolete now

				prevResults = state[modelName]?.[filtername]

				const modelNumberMatch = filtersyntax.match(/model(\d+)/)
				const modelNumber = modelNumberMatch ? parseInt(modelNumberMatch[1], 10) : NaN

				//get all products that are suv or pickup
				let prods = products.filter(f => f.model === modelNumber)

				// is this the first time this playHash is getting results? if so, clear the existing data
				const prevPlayHash = state[modelName]?.[filtername]?.playHash
				if (playHash != prevPlayHash) {
					prevResults = null
				}
				
				prods.forEach(prod => {
					if (data[filtername]?.[prod.uid]) {
						results[prod.uid] = data[filtername][prod.uid]
					}
				})
			}
			else
				results = data[filtername]

			// console.log('results in FORDFORECAST!!!!!', results);
			// console.log('modelname in FORDFORECAST', modelName);

			return {
				...state,
				[modelName]: {
					...state[modelName],
					[filtername]: {
						//...state[modelName]?.[filtername],
						...prevResults,
						playHash,						
						...results 
					}
				}				
			}
		}
			
		case 'CLEAR_FORECASTS':
            return {}       
			
	}

	
	return state
		
}
